export default __webpack_public_path__ + "static/media/gojelly_spielende_bg.748a20ea.jpg";